import { useDeprecation as r } from "./useDeprecation.js";
function c(n) {
  n.forEach((a) => {
    const { props: e } = a || {};
    e != null && e.propValue && (e == null ? void 0 : e.propValue) !== (e == null ? void 0 : e.propDefaultValue) && r(a, "props-name-deprecation-warning");
  });
}
function i(n) {
  n.forEach((a) => {
    const { props: e } = a || {};
    (!e.propName || !(e != null && e.deprecatedValue) ? !1 : (e == null ? void 0 : e.propValue) === (e == null ? void 0 : e.deprecatedValue)) && r(a, "props-value-deprecation-warning");
  });
}
export {
  c as deprecatePropNames,
  i as deprecatePropValues
};
